export default __webpack_public_path__ + "static/media/img.cbd6e9ae.svg";